import React from "react";
import './Servizi.css'
import { Container, Row, Col } from "react-bootstrap";
import {MyAnimatedTypo,MyAnimatedTypo2} from "../Moving";
import CardScroll from "../CardScroll/CardScroll";
import imageUrl1 from "../../Assets/servizi8.png";
import imageUrl2 from "../../Assets/servizi9.png";
import imageUrl3 from "../../Assets/servizi10.png";


function Servizi() {
  return (
    <section>
      <Container fluid className="home-section" id="servizi">
        <Container className="Servizi-content">
 
            <Row md={7} className="Servizi-header">
              <h1 style={{ paddingTop: 40 }}>
              SERVIZI
              </h1>
            </Row>
            <div className="Servizi-rainbow">
              <Row>
                <div>
                  Lo <b>STUDIO BAES</b> grazie alla sua elevata professionalità riesce ad offrire ai suoi clienti <b>SOLUZIONI</b> di
                  vario genere con l’obiettivo di far vivere alle famiglie la propria abitazione al massimo dei comfort
                  e servizi, andando ad <b>OTTIMIZZARE</b> le spese economiche ed eliminare le perdite di tempo attraverso
                  un’<b> AMMINISTRAZIONE CHIARA, PROFESSIONALE ED EFFICACE. </b>
                  In un mondo in costante crescita dove rapidità ed efficienza sono parole d’obbligo, è
                  fondamentale scegliere un <b>PARTNER DI FIDUCIA</b>, scegli <b>BAES</b>!
                    <br></br> 
                    <br></br> 
                    <br></br> 
                    - AMMINISTRAZIONE CONDOMINIALE
                    <br></br> 
                    - TUTELA E STESURA REGOLAMENTO CONDOMINIALE
                    <br></br> 
                    - CONTABILITA’ AGGIORNATA E LEGGIBILE
                    <br></br> 
                    - CONSULENZE CONDOMINIALI
                    <br></br> 
                    - RECUPERO CREDITO CONDOMINIO
                    <br></br> 
                    - ADEMPIMENTI FISCALI
                    <br></br> 
                    - GESTIONE DI BENI IMMOBILI PER CONTO TERZI
                    <br></br> 
                    - COLLABORAZIONE CON AZIENDE FIDATE
                </div>
              </Row>    
            </div> 
            <Row style={{paddingTop: "20px"}}>
            <div section className="cards">
                <CardScroll
                    title="VELOCITA’ DI INTERVENTO"
                    imageUrl= {imageUrl1}
                    body = ""
                />
                <CardScroll
                    title="OTTIMIZZAZIONE DEI COSTI DI CONDOMINIO"
                    imageUrl= {imageUrl2}
                    body = ""
                    />
                <CardScroll
                    title="REPERIBILITA’ 24/7"
                    imageUrl= {imageUrl3}
                    body = ""
                />
            </div>
          </Row>
          <br></br>
          <br></br>
        </Container>  
      </Container>
    </section>
  );
}

export default Servizi;
